module.exports = __webpack_public_path__ + "images/rank_logo_second-b5a6a2639f.png";